import DropdownOption from 'components/Layout/DropdownOption';
import moment from 'moment';
import React, { useState } from 'react';
import { getFilenameFromUrl } from 'utils/helpers';

const MessageBlock = ({
  data,
  is_delete,
  isAccess,
  handleDelete,
  readTickerShow = false,
}) => {
  const {
    id,
    message,
    created_at,
    message_file,
    caption,
    url,
    status,
    is_template,
    template_message,
    file_name,
  } = data;

  const getFileTypeFromUrl = (url) => {
    if (!url) return '';
    const filename = url.split('?')[0];
    const lastPart = filename.split('/').pop();
    const extension = lastPart.split('.').pop().toLowerCase();
    return extension;
  };

  // Usage in your component:
  let fileType = message_file ? getFileTypeFromUrl(message_file) : '';
  const [fileURL, setFileURL] = useState(message_file);

  const formatMessage = (text) => {
    return text
      .split('\n') // Handle new lines
      .map((line, index) => (
        <React.Fragment key={index}>
          {line.split(/(https?:\/\/[^\s]+)/g).map((part, i) =>
            /^https?:\/\//.test(part) ? ( // Check if it's a URL
              <a
                key={i}
                href={part.trim()}
                target="_blank"
                rel="noopener noreferrer"
              >
                {part}
              </a>
            ) : (
              part
            )
          )}
          <br />
        </React.Fragment>
      ));
  };

  return (
    <div>
      {is_delete ? (
        <div className="d-flex gap-5">
          <span className="text-12-400">This message was deleted.</span>
          {isAccess && (
            <span
              className="ps-1 pe-1 border rounded text-12-400 pointer"
              onClick={() => {
                handleDelete(id, 0);
              }}
            >
              Undo
            </span>
          )}
        </div>
      ) : (
        <div>
          {isAccess && (
            <div className="d-flex justify-content-end pointer h-auto">
              <DropdownOption icons={<i className="bi bi-three-dots" />}>
                <div
                  className="d-flex gap-3 text-16-400 ps-3"
                  onClick={() => {
                    handleDelete(id, 1);
                  }}
                >
                  <span>
                    <i className="bi bi-trash text-danger" />
                  </span>
                  <span>Delete</span>
                </div>
              </DropdownOption>
            </div>
          )}
          <div className="d-flex justify-content-between gap-2">
            {message_file || caption ? (
              <>
                <div>
                  {['png', 'jpg', 'jpeg'].includes(fileType) ? (
                    <img
                      src={fileURL}
                      className="fill fit-image"
                      alt="chatImage"
                      style={{
                        height: '150px',
                      }}
                      // onClick={() => window.open(fileURL, '_blank')}
                    />
                  ) : ['txt', 'pdf', 'doc', 'csv', 'docx'].includes(
                      fileType
                    ) ? (
                    <div className="d-flex align-items-center border rounded p-2 gap-4 ">
                      <div className="text-18-400">
                        <i className="bi bi-file-earmark" />
                      </div>
                      <div>{file_name}</div>
                      <div className="ps-2 pe-2 pt-1 pb-1 border rounded pointer">
                        <i
                          className="bi bi-cloud-arrow-down-fill"
                          onClick={() => {
                            window.open(fileURL, '_blank');
                          }}
                        />
                      </div>
                    </div>
                  ) : fileType === 'mp3' ? (
                    <audio key={fileURL} controls>
                      <source src={fileURL} type="audio/mpeg" />
                    </audio>
                  ) : fileType === 'mp4' ? (
                    <>
                      <video width="100%" key={fileURL} controls>
                        <source src={fileURL} type="video/mp4" />
                      </video>
                    </>
                  ) : (
                    'File not suported'
                  )}
                  <div className="cmt-2 ">{caption}</div>
                </div>
              </>
            ) : is_template ? (
              <div>
                {template_message?.map((template, index) => (
                  <div key={index}>
                    {template.header?.type === 'text' && (
                      <h3>{template.header.text}</h3>
                    )}

                    {/* {template.body?.type === 'text' && (
                      <p>{template.body.text}</p>
                    )} */}
                    {template.body?.type === 'text' && (
                      <p>{formatMessage(template.body.text)}</p>
                    )}

                    {template.footer?.type === 'text' && (
                      <p>
                        <i>{template.footer.text}</i>
                      </p>
                    )}

                    {template.button?.length > 0 && (
                      <div className="text-center">
                        <hr />
                        {template.button.map((button, btnIndex) => (
                          <a
                            key={btnIndex}
                            href={button.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              textDecoration: 'none',
                              color: '#112669',
                            }}
                          >
                            <i className="bi bi-box-arrow-up-right cme-5"></i>
                            {button.text}
                          </a>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div>{message}</div>
            )}
          </div>
          {url && (
            <div
              className={`text-decoration-underline pointer ${
                isAccess ? '' : 'color-new-car'
              }`}
              onClick={() =>
                window.open(window.location.origin + url, '_blank')
              }
            >
              {window.location.origin + url}
            </div>
          )}
          <div className="d-flex align-items-center justify-content-end">
            <div className="chat__message__date mt-1 me-2">
              {moment(created_at).format('hh:mm A')}
            </div>
            {readTickerShow && (
              <div>
                {status === '0' && (
                  <i className="bi bi-check " style={{ fontSize: '16px' }} />
                )}
                {status === '1' && (
                  <i className="bi bi-check-all" style={{ fontSize: '16px' }} />
                )}
                {status === '2' && (
                  <i
                    className="bi bi-check-all "
                    style={{ color: '#4caf50', fontSize: '16px' }}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MessageBlock;
